import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import { setRefuseDatasDraft } from '../../../../store/ducks/driver/actions';
import './styles.scss';
interface IRefuseSelect {
  step: number;
}
const RefuseSelect: React.FC<IRefuseSelect> = ({ step }) => {
  const dispatch = useDispatch();
  const [hasReason, setHasReason] = React.useState(false);
  const { rows } = useSelector(
    (state: ApplicationState) => state.reasonRefusal,
  );

  const { status } = useSelector((state: ApplicationState) => state.driver);

  const handleSeRefusedDatas = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    dispatch(
      setRefuseDatasDraft({
        reasonsRefusalDraft: { step, reasonRefusalId: event.target.value },
      }),
    );
  };
  return (
    <span
      style={{
        height: '100px',
        marginLeft: '15px',
      }}
    >
      {' '}
      {status !== 'Ativo' && (
        <button className="refuse-btn" onClick={() => setHasReason(true)}>
          Marcar para revisão
        </button>
      )}
      {hasReason && (
        <select
          className="refuse-select"
          onChange={(event: React.ChangeEvent<HTMLSelectElement>) =>
            handleSeRefusedDatas(event)
          }
        >
          <option>Selecione o Motivo</option>
          {rows?.map((option, index) => (
            <option value={option.reasonRefusalId} key={index}>
              {option.reason}
            </option>
          ))}
        </select>
      )}
    </span>
  );
};

export default RefuseSelect;
